import { apiClient } from './client';

export interface StarMessageItem {
  messageId: string;
  templateKey: string;
  customText: string | null;
  status: string;
  distanceLy: number;
  arrivalDay: number;
  sentAt: string;
  readAt: string | null;
  sender: {
    planetId: string;
    planetName: string;
    ownerName: string | undefined;
    stage: number;
    starIndex: number | null;
  };
  receiver?: {
    planetId: string;
    planetName: string;
    ownerName: string | undefined;
    stage: number;
    starIndex: number | null;
  };
}

export interface InboxResponse {
  messages: StarMessageItem[];
  unreadCount: number;
  radioActive: boolean;
}

export interface OutboxResponse {
  messages: StarMessageItem[];
}

export const messagesApi = {
  getInbox: () => apiClient.get<{ success: boolean; data: InboxResponse }>('/messages/inbox'),
  getOutbox: () => apiClient.get<{ success: boolean; data: OutboxResponse }>('/messages/outbox'),
  markRead: (messageId: string) => apiClient.post<{ success: boolean; data: { read: boolean } }>(`/messages/${messageId}/read`),
  reply: (messageId: string, templateKey: string, customText?: string) =>
    apiClient.post<{ success: boolean; data: { message: { messageId: string; arrivalDay: number; travelDays: number } } }>(`/messages/${messageId}/reply`, { template_key: templateKey, custom_text: customText }),
};
